var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnualService(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 77,
    viewBox: "0 0 113 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 5713"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 5711"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 338",
    d: "M74.6278 40.6306V64.2616C74.6278 65.1628 75.7263 65.6041 76.3498 64.9535L83.4568 57.5375C83.8447 57.1327 84.4895 57.1259 84.8859 57.5223L92.4068 65.0432C93.0368 65.6732 94.1139 65.227 94.1139 64.3361V40.6306",
    stroke: "#172B02",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5710"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 277",
    cx: 84.5779,
    cy: 27.3635,
    r: 15.9131,
    stroke: "#172B02",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 278",
    cx: 84.578,
    cy: 27.3634,
    r: 6.79197,
    stroke: "#172B02",
    strokeWidth: 3
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1874",
    d: "M1.5 5C1.5 3.067 3.067 1.5 5 1.5H107.771C109.704 1.5 111.271 3.067 111.271 5V71.2861C111.271 73.2191 109.704 74.7861 107.771 74.7861H5C3.06701 74.7861 1.5 73.2191 1.5 71.2861V5Z",
    stroke: "#172B02",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 5712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 339",
    d: "M12.8527 26.9491H46.4351",
    stroke: "#172B02",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 340",
    d: "M12.8527 38.1431H46.4352",
    stroke: "#172B02",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 341",
    d: "M12.8527 49.752H46.4352",
    stroke: "#172B02",
    strokeWidth: 3,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualService);
export default __webpack_public_path__ + "static/media/annual-service.16d7e2e3.svg";
export { ForwardRef as ReactComponent };